import Main from "../Home/Main";

function Home() {
	return (
		<>
			<Main></Main>
		</>
	);
}

export default Home;
